
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    MAN_A: "MAN_A",
    MAN_B: "MAN_B",
    PERF: "PERF",
    SUP: "SUP",
    QA: "QA"
};
